import React, { useState, useEffect, useContext, useRef } from 'react';
import LoadingSpinnerImage from "../Shared/LoadingSpinnerImage.js";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./App.css";
import MultiSelectField from "./MultiSelectField.js"
import QueryBuilder from "./QueryBuilder.js";
import { datePopperConfig } from "../Shared/datePopperConfig.js";


const AddItemPopup = ({ globalContext }) => {

    const [hasMoreData, setHasMoreData] = useState(true);
    const [isLoading, setIsLoading] = useState(true);
    const [loadingDataQueue, setLoadingDataQueue] = useState(0);
    const [fieldsConfig, setFieldsConfig] = useState([]); // Facets
    const [query, setQuery] = useState("");
    const [helperTexts, setHelperTexts] = useState(null);
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [responsiblePerson, setResponsiblePerson] = useState(globalContext.currentUserId);
    const [onlyResponsiblePersonCanEdit, setOnlyResponsiblePersonCanEdit] = useState(false);
    const [reviewMode, setReviewMode] = useState(1);
    const [permissions, setPermissions] = useState("False");
    const [addSrStartDate, setAddSrStartDate] = useState("");
    const [addSrEndDate, setAddSrEndDate] = useState("");
    const [errorTitle, setErrorTitle] = useState(false);
    const [errorDescription, setErrorDescription] = useState(false);
    const [errorAddSrStartDate, setErrorAddSrStartDate] = useState(false);
    const [errorChooseFacetsOrQuery, setErrorChooseFacetsOrQuery] = useState(false);
    const [errorAddSrEndDate, setErrorAddSrEndDate] = useState(false);
    const [formState, setFormState] = useState({});
    const [searchValues, setSearchValues] = useState({});
    const [activeDropdown, setActiveDropdown] = useState(null);
    const [availableUsers, setAvailableUsers] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState({});
    const [isCreating, setIsCreating] = useState(false);
    const [minSelectableDate, setMinSelectableDate] = useState(null);
    const [startDateIsMandatory, setStartDateIsMandatory] = useState(false);

    let authoritiesNewsUnique = "authorities-news-all-areas";
    let otherAuthoritiesNewsType = "authorities-news"; // All the other that start with authorities-news*

    const dropdownRefs = useRef({});

    const AppContext = globalContext;


    const maxLengthTitle = 250;
    const maxLengthDescription = 5000;

    
    useEffect(() => {

        loadSrSpecificFields();
        loadAvailableSources();
        loadHelperTexts();


        // Add users to work with multiselect
        let usersAlias = "collaborators";

        let availableUsersList = [{
            Alias: usersAlias,
            Name: "Users",
            Items: AppContext.users.map(user => ({
                Text: user.Name,
                Value: user.Id,
                Disabled: false,
                Group: null,
                Selected: false
            }))
        }];

        let selectedUsersInitialState = { [usersAlias]: [] };

        setAvailableUsers(availableUsersList);
        setSelectedUsers(selectedUsersInitialState);

        defineMinimumDateBySRSection();

    }, []);






    useEffect(() => {

        if (loadingDataQueue > 0)
            setIsLoading(true);
        else
            setIsLoading(false);

    }, [loadingDataQueue]);

    
    const loadHelperTexts = () => {

        let dataUrl = "/umbraco/api/SystematicReviewApi/SystematicReviewText";

        let loadTextsURL = dataUrl + `?` +
            `section=${encodeURIComponent(AppContext.selectedSystematicReviewsTypeAdd)}&`
            ;

        let requestOptions = {};

        setLoadingDataQueue(prev => prev + 1);

        fetch(loadTextsURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401) {
                        AppContext.showAddItemPopup(false);
                        document.dispatchEvent(new Event("api:unauthorized"));
                    }

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                setHelperTexts(result);

            })
            .catch((error) => {
            })
            .finally(() => {
                setLoadingDataQueue(prev => prev - 1);
            });


    }


    const loadSrSpecificFields = () => {

        let dataUrl = "/umbraco/api/SystematicReviewApi/Facets";

        let loadIdsURL = dataUrl + `?` +
            `section=${encodeURIComponent(AppContext.selectedSystematicReviewsTypeAdd)}&`
            ;

        let requestOptions = {};

        setLoadingDataQueue(prev => prev + 1);

        fetch(loadIdsURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401) {
                        AppContext.showAddItemPopup(false);
                        document.dispatchEvent(new Event("api:unauthorized"));
                    }

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                // Sort items
                result.forEach(obj => {
                    if (obj.Items && Array.isArray(obj.Items)) {
                        obj.Items.sort((a, b) => a.Text.localeCompare(b.Text));
                    }
                });

                setFieldsConfig(prev => [...prev, ...result]);

            })
            .catch((error) => {
            })
            .finally(() => {
                setLoadingDataQueue(prev => prev - 1);
            });

    }


    const loadAvailableSources = () => {


        let dataUrl = "/umbraco/api/SystematicReviewApi/AvailableSources";

        let loadIdsURL = dataUrl + `?` +
            `section=${encodeURIComponent(AppContext.selectedSystematicReviewsTypeAdd)}&`
            ;

        let requestOptions = {};

        setLoadingDataQueue(prev => prev + 1);

        fetch(loadIdsURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401) {
                        AppContext.showAddItemPopup(false);
                        document.dispatchEvent(new Event("api:unauthorized"));
                    }

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                // Sort items
                result.sort((a, b) => a.localeCompare(b));

                let availableSourcesField = {
                    Alias: "availableSources",
                    Name: "Sources",
                    Items: result.map(source => (
                        {
                            Text: source,
                            Value: source,
                            Disabled: false,
                            Group: null,
                            Selected: false
                        }))
                };

                setFieldsConfig(prev => [availableSourcesField, ...prev]);

            })
            .catch((error) => {
            })
            .finally(() => {
                setLoadingDataQueue(prev => prev - 1);
            });

    }


    // Initialize form state

    // Initialize form state based on the fields config
    useEffect(() => {
        const initialState = {};

        fieldsConfig.forEach(field => {
            initialState[field.Alias] = field.Items.filter(item => item.Selected).map(item => item.Value);
        });

        setFormState(initialState);
    }, [fieldsConfig]);


    const redirectToSrId = (id, type) => {

        let linkUrl = AppContext.baseLinkUrlForSrs + type + "/" + id + "/";
        window.location = linkUrl;

    }


    const createSR = () => {

        let type = AppContext.selectedSystematicReviewsTypeAdd;
        let isClinicalLiterature = type == "clinical-literature" ? true : false;
        let IsAuhtoritiesNewsSpecific = type.startsWith(otherAuthoritiesNewsType) && type != authoritiesNewsUnique ? true : false;
        let sources = formState["availableSources"];
        let facets = Object.keys(formState).filter(key => key != "availableSources" && key != "collaborators").map(key => ({ Alias: key, Items: formState[key].map(item => ({Text: item, Value: item})) }));
        let collaborators = Object.keys(selectedUsers).filter(key => key == "collaborators").map(key => selectedUsers[key]).join(",");
        let dateFrom = addSrStartDate ? new Intl.DateTimeFormat('en-GB').format(new Date(addSrStartDate)) : null;
        let dateTo = addSrEndDate ? new Intl.DateTimeFormat('en-GB').format(new Date(addSrEndDate)) : null;
        let valid = true;


        let facetsCount = sources.length;
        facets.map(facet => {
            facetsCount += facet.Items.length;
        });

        let queryLength = query.replaceAll("*", "").replaceAll(" ", "").length;


        // Clear errors
        setErrorTitle(false);
        setErrorDescription(false);
        setErrorAddSrStartDate(false);
        setErrorChooseFacetsOrQuery(false);



        if (title == "" || title.length > maxLengthTitle) {
            setErrorTitle(true);
            valid = false;
        }

        if (description.length > maxLengthDescription) {
            setErrorDescription(true);
            valid = false;
        }

        if (dateFrom == null && startDateIsMandatory) {
            setErrorAddSrStartDate(true);
            valid = false;
        }

        if (!isClinicalLiterature && (facetsCount == 0 && (query == "" || queryLength < 3))) {
            setErrorChooseFacetsOrQuery(true);
            valid = false;
        }


        if (!valid)
            return;


        if (sources.length == 0)
            sources = null;

        let sr = {
            "Type": type,
            "Source": sources,
            "IsClinicalLiterature": isClinicalLiterature,
            "IsAuhtoritiesNewsSpecific": IsAuhtoritiesNewsSpecific,
            "ClinicalLiterature": {
                "PubMedKeywords": "",
                "PubMedDateFrom": "",
                "PubMedEndDate": "",
                "PubMedUseExact": true,
                "DoajEnabled": true,
                "DoajKeywords": "",
                "DoajDateFrom": "",
                "DoajEndDate": "",
                "GoogleScholarEnabled": true,
                "GoogleScholarKeywords": "",
                "GoogleScholarFullTextMode": "",
                "GoogleScholarDateFrom": ""
            },
            "Keywords": query,
            "LinkToPlan": null,
            "Collaborators": collaborators,
            "StopCollection": "",
            "DateFrom": dateFrom,
            "DateTo": dateTo,
            "SystematicReviewPermissionStatus": permissions,
            "ResponsiblePerson": responsiblePerson,
            "OnlyResponsiblePersonCanEdit": onlyResponsiblePersonCanEdit,
            "Title": title,
            "Description": description,
            "Mode": reviewMode,
            "Facets": facets
        };



        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(sr)
        };

        let addSRURL =
            `/umbraco/api/SystematicReviewApi/SystematicReview`;

        setIsCreating(true);

        fetch(addSRURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                // Is it a new SR but created when seeing the SR list of a project? Then add it to the project before refreshing
                if (AppContext.srProjectIdFilter) {

                    let url = AppContext.srProjectApiUrl + "ProjectsSRs/?id=" + AppContext.srProjectIdFilter + "&srId=" + result.Id;

                    let requestOptions = {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                    };
                    

                    fetch(url, requestOptions)
                        .then((response) => {
                            if (!response.ok) {
                                if (response.status === 401)
                                    document.dispatchEvent(new Event("api:unauthorized"));

                                throw new Error("Network response was not ok");
                            }
                            return response.json();
                        })
                        .then((projectResult) => {

                            // Add new sr to list
                            AppContext.setData([result, ...AppContext.data]);

                            // Close popup
                            //AppContext.showAddItemPopup(false);

                            // Auto redirect to new SR
                            redirectToSrId(result.Id, type);

                        })
                        .catch((error) => {
                            setIsCreating(false);
                            console.log(error);
                        })
                        .finally(() => {
                        });


                }
                else {

                    // Add new sr to list
                    AppContext.setData([result, ...AppContext.data]);

                    // Close popup
                    //AppContext.showAddItemPopup(false);

                    // Auto redirect to new SR
                    redirectToSrId(result.Id, type);
                    
                }


            })
            .catch((error) => {
                setIsCreating(false);
                console.log(error);
            })
            .finally(() => {
                
            });


    }


    const defineMinimumDateBySRSection = () => {

        let date = null;
        
        

        if (AppContext.selectedSystematicReviewsTypeAdd == authoritiesNewsUnique) {
            date = new Date();
            date.setMonth(date.getMonth() - 1);
            setStartDateIsMandatory(true);
        }
        else if (AppContext.selectedSystematicReviewsTypeAdd.startsWith(otherAuthoritiesNewsType)) {
            date = new Date();
            date.setFullYear(date.getFullYear() - 1);
            setStartDateIsMandatory(true);
        }

        setMinSelectableDate(date);

    }




    const displaySource =
        AppContext.selectedSystematicReviewsTypeAdd.startsWith(otherAuthoritiesNewsType) &&
            AppContext.selectedSystematicReviewsTypeAdd !== authoritiesNewsUnique
            ? "none"
            : "block";


    


    return (
        <div id="add-popup-background">
            <div className="add-task-popup" style={{position: "static"}}>
                <div style={{ display: "flex", flexDirection: "row" }}>
                    <div style={{ width: "50%" }}>
                        <h3>Add {AppContext.singleItemTitle}</h3>
                    </div>
                    <div style={{ width: "50%", textAlign: "right" }}>
                        <button
                            className="close-button"
                            onClick={() => AppContext.showAddItemPopup(false)}
                        >
                            <i className="fas fa-times"></i>
                        </button>
                    </div>
                </div>


            
                {isLoading ? <>
                    <LoadingSpinnerImage />
                </> : <>

                    <div dangerouslySetInnerHTML={{ __html: helperTexts ? helperTexts.CategoryTips : null }} />

                    <br />
                    <div dangerouslySetInnerHTML={{ __html: helperTexts ? helperTexts.TitleText : null }} />


                    <label className="create-sr-field-title">Title</label>

                    <input
                        value={title}
                        className={`form-field-text add-task-field-name ${errorTitle ? "form-field-error" : null
                            }`}
                        onChange={(e) => e.target.value.length <= maxLengthTitle ? setTitle(e.target.value) : null}
                        style={{ width: "100%" }}                 
                        type="text"
                        placeholder="Title"
                    />
                    {errorTitle && (
                        <span className="form-field-error-message">
                            This field is necessary, maximum size {maxLengthTitle}
                        </span>
                    )}
                    <br />
                    <br />



                    <label className="create-sr-field-title">Description</label>

                    <div dangerouslySetInnerHTML={{ __html: helperTexts ? helperTexts.DescriptionText : null }} />
            
                    <textarea
                        value={description}
                        className={`form-field-text add-task-field-description`}
                        style={{ width: "100%" }}
                        placeholder="Description"
                        onChange={(e) => e.target.value.length <= maxLengthDescription ? setDescription(e.target.value) : null}
                    ></textarea>
                    {errorDescription && (
                        <span className="form-field-error-message">
                            Maximum size is {maxLengthDescription}
                        </span>
                    )}
                    <br />
                    <br />



                    <div style={{ width: "100%", }}>
                
                        <label className="create-sr-field-title">Responsible Person</label>
                    
                        {helperTexts && helperTexts.ResponsiblePersonText != "" ? <>
                            <div dangerouslySetInnerHTML={{ __html: helperTexts ? helperTexts.ResponsiblePersonText : null }} />
                        </> : null}
                        <select
                            value={responsiblePerson}
                            onChange={(e) => setResponsiblePerson(e.target.value)}
                            className="sr-create-form-dropdown"
                        >
                            {AppContext.users.map((user, index) => (
                                <option key={index} value={user.Id}>
                                    {user.Name}
                                </option>
                            ))}
                        </select>

                    </div>

                    <div style={{ width: "100%", }}>
                
                        <label className="create-sr-field-title"></label>
                    
                        {helperTexts && helperTexts.OnlyResponsiblePersonCanEditText != "" ? <>
                            <div dangerouslySetInnerHTML={{ __html: helperTexts ? helperTexts.OnlyResponsiblePersonCanEditText : null }} />
                        </> : null}

                        <label>
                                <input type="checkbox" value={onlyResponsiblePersonCanEdit} onChange={(e) => setOnlyResponsiblePersonCanEdit(e.target.checked)} /> <span style={{ fontWeight: "500", marginLeft:"10px"}} >Only Responsible Person can edit the SR settings</span>
                        </label>

                    </div>

                    <br/>



                    <div style={{ width: "100%", }}>
                        
                        <label className="create-sr-field-title">Review Mode</label>
                        <select
                            value={reviewMode}
                            onChange={(e) => setReviewMode(e.target.value)}
                            className="sr-create-form-dropdown"
                        >
                            <option value="1">One Time</option>
                            <option value="2">Continuous</option>
                        </select>
                    </div>

                    <br />

                    <div style={{ width: "100%", }}>

                        <label className="create-sr-field-title">Permissions</label>
                        {helperTexts && helperTexts.HelpTextForPrivate != "" ? <>
                            <div dangerouslySetInnerHTML={{ __html: helperTexts ? helperTexts.HelpTextForPrivate : null }} />
                        </> : null}

                        <select
                            value={permissions}
                            onChange={(e) => setPermissions(e.target.value)}
                            className="sr-create-form-dropdown"
                        >
                            <option value="False">Accessible to all users</option>
                            <option value="True">Restricted access</option>
                        </select>

                        {permissions == "True" ? <>

                            <div style={{marginTop: "15px"}}>Collaborators with permission to access this Systematic Review</div>

                            {helperTexts && helperTexts.HelpTextForCollaborators != "" ? <>
                                <div dangerouslySetInnerHTML={{ __html: helperTexts ? helperTexts.HelpTextForCollaborators : null }} />
                            </> : null}

                            <MultiSelectField field={{
                                Alias: "collaborators",
                                    Name: "",
                                Items: AppContext.users.map(user => (
                                    {
                                        Text: user.Name,
                                        Value: user.Id,
                                        Disabled: false,
                                        Group: null,
                                        Selected: false
                                    }))
                                }}
                                formState={selectedUsers}
                                setFormState={setSelectedUsers}
                                fieldsConfig={availableUsers}
                                searchValues={searchValues}
                                setSearchValues={setSearchValues}
                                activeDropdown={activeDropdown}
                                setActiveDropdown={setActiveDropdown}
                                dropdownRefs={dropdownRefs}
                                />

                        </> : null}
                    </div>

                    <br/>




                    {AppContext.selectedSystematicReviewsTypeAdd != "clinical-literature" ? <>

                            <div style={{margin: "5px", padding: "20px", borderRadius: "15px", border: "1px solid #ccc", backgroundColor: "#f4f5f7"}}>
                            <h3>Create your search</h3>
                            <p>Use the filters or query to create your search. It is not necessary to fill all the fields. Selections within the same filter works as OR logic.</p>
                                                

                            {/* FACETS */}

                                {fieldsConfig.map((field, index) => {

                                    // Hide sources field if it's an authorities news but not a authorities-news-all-areas
                                    if (field.Alias == "availableSources") {
                                        let type = AppContext.selectedSystematicReviewsTypeAdd;
                                        let IsAuhtoritiesNewsSpecific = type.startsWith(otherAuthoritiesNewsType) && type != authoritiesNewsUnique ? true : false;

                                        if (IsAuhtoritiesNewsSpecific)
                                            return;
                                    }


                                    return (
                                        <div key={index}>

                                            <MultiSelectField field={field}
                                                formState={formState}
                                                setFormState={setFormState}
                                                fieldsConfig={fieldsConfig}
                                                searchValues={searchValues}
                                                setSearchValues={setSearchValues}
                                                activeDropdown={activeDropdown}
                                                setActiveDropdown={setActiveDropdown}
                                                dropdownRefs={dropdownRefs}
                                            />

                                            <div className="sr-search-operator-and">AND</div>
                                        </div>
                                    )}

                                )}

                


                            {/* QUERY */}

                            <label className="create-sr-field-title">Query</label>

                            <div dangerouslySetInnerHTML={{ __html: helperTexts ? helperTexts.KeywordsText : null }} />

                            <QueryBuilder key="querybuilder" query={query} setQuery={setQuery} />

                            {errorChooseFacetsOrQuery ?
                                <div style={{ width: "100%" }}>
                                    <span className="form-field-error-message">
                                        Add either a query (minimum 3 characters, excluding * wildcard and spaces) or at least one filter
                                    </span>
                                </div>
                            : null}




                            <div className="sr-search-operator-and">AND</div>

                            {/* DATES */}

                            <div style={{ width: "100%", display: "flex", flexDirection: "column" }}>
                                <div>
                                    <label className="create-sr-field-title">Start Date</label>
                                </div>
                                <div dangerouslySetInnerHTML={{ __html: helperTexts ? helperTexts.InititalDateText : null }} />
                                <div>
                                    <DatePicker
                                        className={`datepicker-field add-task-field-date-start ${errorAddSrStartDate ? "form-field-error" : null
                                            }`}
                                        dateFormat="yyyy-MM-dd"
                                        maxDate={new Date()}
                                        selected={addSrStartDate}
                                        minDate={minSelectableDate}
                                        onChange={(date) => {
                                                setAddSrStartDate(date);
                                            }}
                                        popperPlacement={datePopperConfig.placement}
                                        popperModifiers={datePopperConfig.modifiers}
                                    />
                                    {errorAddSrStartDate && (
                                        <div style={{width: "100%"}}>
                                            <span className="form-field-error-message">
                                                This field is necessary
                                            </span>
                                        </div>
                                    )}
                                </div>
                            </div>

                                <div style={{ display: reviewMode == 2 ? "none" : "block"}} className="sr-search-operator-and">AND</div>

                                <div style={{ width: "100%", display: reviewMode == 2 ? "none" : "flex", flexDirection: "column" }} >
                                <div>
                                    <label className="create-sr-field-title">End Date</label>
                                </div>
                                <div dangerouslySetInnerHTML={{ __html: helperTexts ? helperTexts.StopDateText : null }} />
                                <div>
                                    <DatePicker
                                        className={`datepicker-field ${errorAddSrEndDate ? "form-field-error" : null
                                            }`}
                                        dateFormat="yyyy-MM-dd"
                                        maxDate={new Date()}
                                        selected={addSrEndDate}
                                        onChange={(date) => {
                                                setAddSrEndDate(date);
                                            }}
                                        popperPlacement={datePopperConfig.placement}
                                        popperModifiers={datePopperConfig.modifiers}
                                    />
                                    {errorAddSrEndDate && (
                                        <div style={{width: "100%"}}>
                                            <span className="form-field-error-message">
                                                This field is necessary
                                            </span>
                                        </div>
                                    )}
                                </div>
                            </div>


                        </div>

                    </> : null}






                    {/* BUTTONS */}

                    <div className="action-button-bar">
                        <div className="action-button-bar-left">
                            <button
                                className="action-button cancel-button"
                                onClick={() => AppContext.showAddItemPopup(false)}
                            >
                                Close
                            </button>
                        </div>
                        <div className="action-button-bar-center"></div>
                        <div className="action-button-bar-right">

                                {isCreating? 
                                <>
                                    <LoadingSpinnerImage />
                                </> : <>
                                    <button
                                    className="action-button save-button"
                                    onClick={() => createSR()}
                                >
                                    Create
                                    </button>
                                </>}

                        </div>
                    </div>

                </>}

            </div>
        </div>
    );
};


export default AddItemPopup;

